import { formatDanishDate, formatDanishDateTime } from '../danishDateTime';

/**
 * Date and time for sent referrals and their receipts, in the shared Danish
 * format (Europe/Copenhagen), e.g. "15-10-2026 14:32" (MedCom CTL-Modtagelse
 * 3.10 / 3.14: send time and receipt time shown as two separate facts).
 */
export function formatReferralDateTime(iso: string | null | undefined): string | null {
  return formatDanishDateTime(iso) || null;
}

/** Date only, Danish, Europe/Copenhagen — referral list and detail received_at. */
export function formatReferralDate(iso: string | null | undefined): string | null {
  return formatDanishDate(iso) || null;
}

/** communicate-ctl sync-referrals `receiptTimes` → referral id → ISO time. */
export function receiptTimesById(
  times: readonly { referralId: string; receivedAt: string | null }[] | undefined,
): Record<string, string> {
  const byId: Record<string, string> = {};
  for (const time of times ?? []) {
    if (time.referralId && time.receivedAt) byId[time.referralId] = time.receivedAt;
  }
  return byId;
}
